import { MDSTheme, MDSTypography } from '@marqvision/mds/core';
import { Button, ButtonProps, makeStyles } from '@material-ui/core';
import clsx from 'classnames';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: 'flex-start',
    width: '100%',
    height: '32px',
    textTransform: 'none',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: MDSTheme.palette.white,
    borderRadius: '16px',
    padding: '0 12px',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, fill 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: MDSTheme.palette.white,
    },

    '& .drawerButtonLabel': {
      transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, fill 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '&:hover .drawerButtonLabel': {
      color: `${MDSTheme.palette.blue[700]} !important`,
    },
    '& svg > path': {
      transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, fill 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '&:hover svg > path': {
      fill: `${MDSTheme.palette.blue[700]} !important`,
    },
  },
  light: {
    height: '32px',
    '&:hover': {
      backgroundColor: MDSTheme.palette.blue[50],
    },
  },
  selected: {
    backgroundColor: MDSTheme.palette.white,
    color: MDSTheme.palette.blue[700],
  },
  selectedLight: {
    backgroundColor: MDSTheme.palette.blue[50],
  },
}));

interface IOwnProps {
  selected?: boolean;
  variant?: 'normal' | 'light';
}

type IProps = IOwnProps & Omit<ButtonProps, 'variant'>;

const MenuButton = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const { selected = false, variant, children, ...restProps } = props;

  return (
    <Button
      {...restProps}
      className={clsx(classes.root, {
        [classes.light]: variant === 'light',
        [classes.selected]: selected,
        [classes.selectedLight]: variant === 'light' && selected,
      })}
      disableRipple
    >
      <MDSTypography
        className="drawerButtonLabel"
        variant={variant === 'light' ? 'T14' : 'T14'}
        weight="medium"
        style={{
          color: selected
            ? MDSTheme.palette.blue[700]
            : variant === 'light'
            ? MDSTheme.palette.bluegray[800]
            : MDSTheme.palette.white,
        }}
      >
        {children}
      </MDSTypography>
    </Button>
  );
};

export default MenuButton;
